var popup = $(".miles-popup");
$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll + $(window).height() >= $(document).height() - $('footer.footer').height()) {
        popup.removeClass("show");
    } else if (scroll >= 200) {
        popup.addClass("show");
    } else {
        popup.removeClass("show");
    }
});



// WEBPACK FOOTER //
// app/javascript/frontend/miles-popup.js